module.exports = __webpack_public_path__ + "img/mic-fill.8b524c6e.svg";